import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { createAttachmentsApi } from '#/api/platform/attachments';

const MULTIPART_HEADERS = { 'Content-Type': undefined };

/**
 * 憑證附件單一步驟上傳：前端標準 request 不再建 upload batch（`/upload-batches` 已 Deprecated）。
 * 共用 DocumentAttachmentsCard 仍會先呼叫 createUploadBatch，故回本地佔位值，upload 忽略它。
 */
const SINGLE_STEP_BATCH = { data: { uploadBatchId: 'single-step' } };

const baseApi = createAttachmentsApi(
  (voucherId) => `/fms/vouchers/${voucherId}/attachments`,
);

async function createUploadBatch() {
  return SINGLE_STEP_BATCH;
}

/** POST `/fms/vouchers/{id}/attachments`：multipart `file` 必填、`remark` 選填。 */
async function upload(voucherId, { file, remark }) {
  const formData = new FormData();
  formData.append('file', file);
  if (remark != null && remark !== '') {
    formData.append('remark', remark);
  }

  const { data: raw } = await request.post(
    `/fms/vouchers/${voucherId}/attachments`,
    formData,
    { headers: MULTIPART_HEADERS },
  );
  return parseVer4DetailResponse(raw);
}

export const voucherAttachmentsApi = {
  ...baseApi,
  createUploadBatch,
  upload,
};

/**
 * 由請款單讀關聯憑證附件（唯讀）：GET 皆帶 `payment_request_id`，後端以請款單可見性授權。
 * 讀取權不賦予寫入權，畫面須 readOnly。
 */
export function createLinkedVoucherAttachmentsApi(paymentRequestId) {
  return createAttachmentsApi(
    (voucherId) => `/fms/vouchers/${voucherId}/attachments`,
    { readParams: { payment_request_id: paymentRequestId } },
  );
}
